import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import DesktopSignIn from '@/components/Auth/DesktopSignIn';
export default function DesktopSignInRoute() {
  const { id } = useLocalSearchParams();
  return <DesktopSignIn id={typeof id === 'string' ? id : ''} />;
}
